import React from 'react';
import { 
  SignedIn, 
  SignedOut, 
  UserButton,
  useUser,
  SignIn,
  SignUp
} from '@clerk/clerk-react';
import EnhancedDashboard from './EnhancedDashboard';

function App() {
  // Check if we're on invitation acceptance or sign-in page based on URL
  const currentPath = window.location.pathname;
  
  // Handle invitation acceptance
  if (currentPath === '/accept-invitation' || currentPath === '/sign-up') {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9fafb',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '500px' }}>
          <div style={{ marginBottom: '24px' }}>
            <span style={{ fontSize: '3rem', marginBottom: '16px', display: 'block' }}>🏥</span>
            <h1 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '1.75rem', 
              fontWeight: 'bold',
              color: '#111827'
            }}>
              Healthcare Policy Monitor
            </h1>
            <p style={{ 
              margin: '0 0 16px 0', 
              fontSize: '1rem', 
              color: '#6b7280' 
            }}>
              Complete your invitation to access the AI-powered policy intelligence platform
            </p>
          </div>
          
          <SignUp 
            afterSignUpUrl="/"
            redirectUrl="/"
            appearance={{
              elements: {
                rootBox: {
                  margin: '0 auto'
                },
                card: {
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                }
              }
            }}
          />
        </div>
      </div>
    );
  }

  // Handle sign-in
  if (currentPath === '/sign-in') {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9fafb',
        fontFamily: 'Arial, sans-serif'
      }}>
        <div style={{ textAlign: 'center', maxWidth: '500px' }}>
          <div style={{ marginBottom: '24px' }}>
            <span style={{ fontSize: '3rem', marginBottom: '16px', display: 'block' }}>🏥</span>
            <h1 style={{ 
              margin: '0 0 8px 0', 
              fontSize: '1.75rem', 
              fontWeight: 'bold',
              color: '#111827'
            }}>
              Healthcare Policy Monitor
            </h1>
            <p style={{ 
              margin: '0 0 16px 0', 
              fontSize: '1rem', 
              color: '#6b7280' 
            }}>
              Sign in to access your AI-powered policy intelligence dashboard
            </p>
          </div>
          
          <SignIn 
            afterSignInUrl="/"
            redirectUrl="/"
            appearance={{
              elements: {
                rootBox: {
                  margin: '0 auto'
                },
                card: {
                  boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                }
              }
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <SignedOut>
        {/* Landing page for unauthenticated users (Invite-Only) */}
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f9fafb',
          fontFamily: 'Arial, sans-serif'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '40px',
            borderRadius: '12px',
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
            textAlign: 'center',
            maxWidth: '400px',
            width: '100%'
          }}>
            <div style={{ marginBottom: '24px' }}>
              <span style={{ fontSize: '3rem', marginBottom: '16px', display: 'block' }}>🏥</span>
              <h1 style={{ 
                margin: '0 0 8px 0', 
                fontSize: '1.75rem', 
                fontWeight: 'bold',
                color: '#111827'
              }}>
                Healthcare Policy Monitor
              </h1>
              <p style={{ 
                margin: 0, 
                fontSize: '1rem', 
                color: '#6b7280' 
              }}>
                AI-Powered Policy Intelligence Platform
              </p>
            </div>
            
            <div style={{
              backgroundColor: '#f8fafc',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '24px',
              border: '1px solid #e2e8f0'
            }}>
              <h3 style={{ margin: '0 0 12px 0', color: '#374151' }}>Exclusive Access Platform:</h3>
              <ul style={{ 
                textAlign: 'left', 
                margin: 0, 
                paddingLeft: '20px',
                color: '#6b7280',
                fontSize: '0.875rem'
              }}>
                <li>🤖 AI-analyzed policy changes</li>
                <li>📊 Real-time healthcare updates</li>
                <li>🔍 Advanced policy intelligence</li>
                <li>⚡ Impact assessments</li>
              </ul>
            </div>

            <div style={{
              backgroundColor: '#fef3c7',
              padding: '20px',
              borderRadius: '8px',
              marginBottom: '24px',
              border: '1px solid #f59e0b'
            }}>
              <h3 style={{ margin: '0 0 8px 0', color: '#92400e' }}>🔐 Invite-Only Access</h3>
              <p style={{ 
                margin: 0, 
                fontSize: '0.875rem', 
                color: '#92400e',
                lineHeight: '1.4'
              }}>
                This platform requires an invitation. If you have an invitation link, use it to create your account.
              </p>
            </div>

            <button 
              onClick={() => window.location.href = '/sign-in'}
              style={{
                width: '100%',
                padding: '12px 24px',
                backgroundColor: '#2563eb',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1rem',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                marginBottom: '16px'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#1d4ed8'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#2563eb'}>
              🔐 Sign In (Existing Users)
            </button>
          </div>
        </div>
      </SignedOut>

      <SignedIn>
        {/* Protected Dashboard for authenticated users */}
        <EnhancedDashboard />
      </SignedIn>
    </div>
  );
}

export default App;